import React from 'react'
import classes from "./style.module.scss";
import { Icons } from '../../../../assets';
import CounterComponent from '../../../../component/CounterComponent';

const SystemOverview = (props) => {
    const { dashboardCount } = props
    return (
        <div className={`eventWrapper mt-4`}>
            <div className={`component-title flex items-center`}>
                <div className='label'>System Overview</div>
                <div className='vector'></div>
            </div>
            <div className={`eventWrapper ${classes.dashboardCardWrapper}`}>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.user} /></div>
                        <div className={`${classes.cardDescription}`}>Total Users</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalUser} alt='Total Users' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.verifiedRetailerAndMechanicThisMonth} /></div>
                        <div className={`${classes.cardDescription}`}>Verified Retailers/Mechanics joined this month</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalProducts} alt='Total Products' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.qr} /></div>
                        <div className={`${classes.cardDescription}`}>Total QRs Generated</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalQR} alt='Total QR' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.feedback} /></div>
                        <div className={`${classes.cardDescription}`}>Total Feedback</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalFeedback} alt='Total Feedback' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.openRedeemRewards} /></div>
                        <div className={`${classes.cardDescription}`}>Total Open Redeem Rewards</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.openRedeemRewards} alt='Total openRedeemRewards' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.retailerIncompleteAndPendingVerification} /></div>
                        <div className={`${classes.cardDescription}`}>Retailers: Incomplete/Pending Verification</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalInCompleteRetailers} alt='Total Incomplete Retailers' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.mechanicIncompleteAndPendingVerification} /></div>
                        <div className={`${classes.cardDescription}`}>Mechanics: Incomplete/Pending Verification</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalIncompleteMechanics} alt='Total Incomplete Mechanics' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.openEnquiries} /></div>
                        <div className={`${classes.cardDescription}`}>Total Open Enquiries</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalOpenEnquiries} alt='Total Open Enquiries' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.openContactForms} /></div>
                        <div className={`${classes.cardDescription}`}>Total Open Contact Forms</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalOpenContactForms} alt='TotalOpenContactForms' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.retailerVerifiedWithoutTarget} /></div>
                        <div className={`${classes.cardDescription}`}>Total Retailer Verified Without Target</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalRetailerVerifiedWithoutTarget} alt='Total Retailer Verified Without Target' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.totalVerifiedRetailer} /></div>
                        <div className={`${classes.cardDescription}`}>Total Verified Retailers</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalRetailerVerifiedWithoutTarget} alt='Total Retailer Verified Without Target' />
                    </div>
                </div>
                <div className={`${classes.dashboardCard} flex items-center`}>
                    <div className={`w-[70%]`}>
                        <div className={`${classes.cardCount}`}><CounterComponent endValue={dashboardCount?.totalVerifiedMechanic} /></div>
                        <div className={`${classes.cardDescription}`}>Total Verified Mechanics</div>
                    </div>
                    <div className={`w-[25%] ml-auto`}>
                        <img src={Icons?.totalRetailerVerifiedWithoutTarget} alt='Total Retailer Verified Without Target' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SystemOverview